const axios = require("axios");

const instance = axios.create({
  // baseURL: "http://192.168.1.107:90/api",//nyangena
  // baseURL: "http://197.248.111.170:207/api", // nyangena remote
  // baseURL: "http://192.168.1.229:72/api",//code
  //baseURL: " http://localhost:73/api",//code not net
 // baseURL: " http://localhost:74/api",//code not net

   //baseURL: "http://192.168.1.9:90/api",//racecourse
  // baseURL: "http://197.232.67.112:90/api",
  // baseURL: "http://192.168.1.11:90/api",
  // baseURL: "http://197.248.67.254:90/api",
  // baseURL: "http://197.248.111.170:85/api",
  //  baseURL: "http://197.248.111.170:811/api",
  //baseURL: "http://197.248.67.254:90/api",//dental
   //baseURL: "http://192.168.1.44:60/api", //nakuru specialist
   //baseURL: "http://192.168.1.107:94/api",//kisii specialist
   //  baseURL: "http://197.248.67.254:210/api",//,// kisii specialist remote
   //  baseURL: "http://192.168.1.142:90/api",//,// Nairobi Outpatient
   //  baseURL: "http://192.168.1.54:90/api",//,// Birita
 //baseURL: "http://192.168.100.5:90/api",//,// care
 //baseURL: "http://197.248.117.43:90/api",//,// care o
  //baseURL: "http://192.168.1.54:90/api",//birita
 // baseURL: "http://41.90.122.183:90/api",//birita remote
 
 baseURL: "https://hmis.radiocarehospital.com:91/api",//radiocare 
 //baseURL: "https://hmiskaps.radiocarehospital.com:93/api",//,// RadioCare kaps
});

instance.interceptors.request.use(
  function(config) {

    return config;
  },
  function(error) {

    return Promise.reject(error);
});

instance.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    const errors = Object.values(error.response.data);

    if (errors.length) {
      window.Swal.fire({ text: errors.join(" "), type: "error" });
    } else {
      window.Swal.fire({ text: error.response.data.message, type: "error" });
    }

    return Promise.reject(error);
  }
);

export default instance;
